<template>
  <div :class="$style.h5sdk" :style="{ backgroundImage: `url('${background}')` }">
    <!-- 新增鸿蒙系统检测提示 -->
    <div :class="$style.harmonyDetect" v-if="harmonyDetectVisible">
      <div :class="$style.harmonyDetectContent">
        <h3>鸿蒙系统检测提示</h3>
        <p>检测到鸿蒙系统 (HarmonyOS)</p>
        <p>版本: {{ harmonyVersion }}</p>
        <p>用户代理: {{ harmonyUserAgent }}</p>
        <div :class="$style.harmonyActions">
          <button @click="closeHarmonyDetect">关闭</button>
          <button @click="showHarmonyDetails">查看详情</button>
        </div>
      </div>
    </div>
    <!-- 手机登录 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.cellLoginVisible">
      <!-- <cell-register @back="redirectLogin" @register="handleCellRegister" @redirectArgument="redirectArgument"></cell-register> -->
      <cell-login 
        @redirectRegist="redirectRegist" 
        @redirectAccountLogin="redirectAccountLogin" 
        @redirectArgument="redirectArgument"
        @login="cellLogin"
        :hideRegister="hideRegister"
        ref="cellLogin"
      ></cell-login>
    </div>
    <!-- 快速注册 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.quickRegisterVisible">
      <quick-register
        @redirectAccountLogin="redirectAccountLogin"
        @redirectCellLogin="redirectCellLogin"
        @register="handleQuickRegister"
        @redirectArgument="redirectArgument"
      ></quick-register>
    </div>
    <!-- 登录 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.loginVisible">
      <Login @login="handleLogin" @redirectRegist="redirectRegist" @redirectForget="redirectForget" :hideRegister="hideRegister" @redirectArgument="redirectArgument" @redirectCellLogin="redirectCellLogin"></Login>
    </div>
    <!-- 忘记密码 -->
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="userState.resetVisible">
      <Reset @back="redirectLogin"></Reset>
    </div>
    <!-- 悬浮球 -->
    <Suspend v-if="userState.suspendVisible"></Suspend>
    <!-- 悬浮窗 -->

    <!-- 公告 -->
    <Affiche v-if="userState.afficheShow" @close="closeAffiche"></Affiche>
    <!-- 强更新活动 -->
    <!-- <ForceUpdate v-if="userState.forceUpdateVisible" @toLogin="toLogin"></ForceUpdate> -->
    <!-- 防沉迷 -->
    <AntiIndulged v-if="userState.antiIndulgedVisible" @notifyLogin="enterGame"></AntiIndulged>
    <!-- 支付 -->
    <Charge v-if="userState.chargeVisible" @close="closeChargeWindow"></Charge>
    <!-- 滑块验证 -->
    <Captcha :class="$style.captcha" v-show="userState.captchaVisible" @captchaInit="captchaInit"></Captcha>
    <!-- vip客服 -->
    <VipCustomer v-if="userState.vipVisible"></VipCustomer>
    <div :class="[$style.outer, background == '' ? $style.mask : '', $style.argument]" v-if="userState.argumentVisible">
      <Argument @redirectRegist="argumentReturn"></Argument>
    </div>
    <div :class="[$style.outer, background == '' ? $style.mask : '', $style.argumentTip]" v-if="argumentTipVisible">
      <ArgumentTip @agreeArgument="agreeArgument" @back="argumentTipVisible=false" @showArgument="redirectArgument"></ArgumentTip>
    </div>
    <FloatWindow v-if="userState.floatWindowVisible"></FloatWindow>
    <!-- 强制绑定手机 -->
    <ForceBindPhone v-if="userState.forceBindVisible" @close="closeForceBind" :normalTelBind="normalTelBind"></ForceBindPhone>
    <!-- 应用宝登录框 -->
    <!-- <YybLogin v-if="userState.yybLoginVisible"></YybLogin> -->
    <!-- iOS h5 他添加桌面提示 -->
    <iosTips v-if="userState.iosTips"></iosTips>
    <!-- 游戏frame -->
    <!--iframe :class="$style.gameFrame" name="gameFrame" src="https://dev-sdk-static.zhangyuqu.com/demo.html?t=7777" v-if="userState.gameVisible"></iframe -->
    <iframe :class="$style.gameFrame" name="gameFrame" src="https://testgame.kg.qq.com/tmegames/thirdpartyxxl_test/index.html?appId=80000003&formid=thirdparty" v-if="userState.gameVisible"></iframe>

    <!-- 活动页 -->
    <ActivityPage v-if="activityShowInfo.visible"></ActivityPage>
    <!-- 冻结账号强制下线弹窗 -->
    <ForceOffline v-if="userState.forceOfflineVisible"></ForceOffline>
    <!-- 收到优惠券提示 -->
    <!-- <VoucherHint v-if="voucherState.voucherHintVisible"></VoucherHint> -->
    <!-- 强更转移礼包 -->
    <UpdateGift v-if="userState.updateGiftVisible" @close="closeUpdateGift"></UpdateGift>
    <div :class="[$style.outer, background == '' ? $style.mask : '']" v-if="guideRemindVisible">
      <GuideRemind @close="closeGuideRemind"></GuideRemind>
    </div>
    <!-- 静默登录欢迎用户登录提示 -->
    <div :class="$style.hint" v-if="hintShow">
      用户（<span>{{ userState.username }}</span>），欢迎进入游戏。
    </div>
    <img :src="`${$cdnLink}/common/lead.png`" alt="" v-if="guideBrowserVisible" :class="$style.guideBrowser" @click="hideGuideBrowser">
  </div>
</template>
<script>
import QuickRegister from '@/components/login/RegisterV2/index.vue';
import CellLogin from '@/components/login/CellLogin/index.vue';
import Login from '@/components/login/LoginV2/index.vue';
import Suspend from './suspend.vue';
import Reset from '@/components/login/Forgetpswds/index.vue';
import Affiche from '@/components/login/Affiche/index.vue';
import AntiIndulged from './antiIndulged.vue';
import Charge from '@/components/charge/Charge/index.vue'
import Captcha from '@/components/login/Captcha/index.vue'
import VipCustomer from './vipCustomer.vue'
import Argument from '@/components/login/Argument/index.vue'
import FloatWindow from './floatWindow.vue'
import ForceBindPhone from '@/components/login/ForceBindPhone/index.vue'
import ActivityPage from './activityPage.vue'
import ForceOffline from './forceOffline.vue'
import UpdateGift from '@/components/update/Gift.vue'
import ArgumentTip from '@/components/login/ArgumentTip/index.vue'
import GuideRemind from '@/components/charge/GuideRemind.vue'

import iosTips from '@/components/iosTips.vue';

import { mapState } from 'vuex';
import { isAndroid,isSysName,getStorage,isSafari,isStandalone } from '@/libs/utils.js';
// 新增鸿蒙检测函数
const HarmonyDetector = {
  // 检测是否为鸿蒙系统
  isHarmonyOS: function() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.includes('harmonyos') || ua.includes('hmos');
  },
  
  // 检测是否为鸿蒙WebView
  isHarmonyWebView: function() {
    const ua = navigator.userAgent;
    return ua.includes('Harmony') || 
           ua.includes('HUAWEI-HarmonyOS') || 
           typeof window.Harmony !== 'undefined' || 
           typeof window.hmos !== 'undefined';
  },
  
  // 获取鸿蒙版本
  getHarmonyVersion: function() {
    const ua = navigator.userAgent;
    const versionPatterns = [
      /harmonyos\s*(\d+(?:\.\d+)*)/i,
      /hmos\s*(\d+(?:\.\d+)*)/i,
      /harmony\s*os\s*(\d+(?:\.\d+)*)/i
    ];
    
    for (const pattern of versionPatterns) {
      const match = ua.match(pattern);
      if (match && match[1]) {
        return match[1];
      }
    }
    return '未知';
  },
  
  // 综合检测
  detectHarmony: function() {
    return {
      isHarmonyOS: this.isHarmonyOS(),
      isHarmonyWebView: this.isHarmonyWebView(),
      version: this.getHarmonyVersion(),
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      deviceType: this.getDeviceType(),
      timestamp: new Date().toISOString()
    };
  },
  
  // 获取设备类型
  getDeviceType: function() {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.includes('mobile')) return '手机';
    if (ua.includes('tablet')) return '平板';
    if (ua.includes('tv')) return '电视';
    if (ua.includes('watch')) return '手表';
    return '未知设备';
  }
};
import {
  thirdPartyLogins,
  registJSInitial,
  innerPurchaseFunctionSuc,
  closeOrderFrame,
  checkOrderState,
  deviceFlip2H5,
  onBackPressed2H5,
  getInitialInfo
} from '@/bridge/AppJsBridge';
import { getAccount, getCellAccount, setStorage, saveCellAccount, delCellAccount } from '@/libs/utils';
import { CaptchaInit, CaptchaReset } from "@/libs/captcha";

export default {
  metaInfo() {
    return {
      title: this.$store.state.user.app_name, // 正确：使用箭头函数，可以访问 this
      meta: [
        { name: 'viewport', content: 'width=device-width,initial-scale=1.0,user-scalable=no' },
        { name: 'apple-mobile-web-app-capable', content: 'yes' },
      ],
      link:[
        {rel:'apple-touch-icon-precomposed',href:'https://sdk-static.zhangyuqu.com/icon/app/slzs.png'}
      ],
    };
  },
  data() {
    return {
      registerCallback: '', // 暂存滑块验证成功后需要调用的回调方法名
      cellForm: {}, // 手机滑块注册时暂存表单信息
      normalTelBind: false, // 是登录后show_tel_bind
      argumentTipVisible: false, //协议提示
      argumentHandle: {
        method: '',
        params: {}
      },  // 显示勾选协议提示后点击同意进入游戏的回调
      hideRegister: true,
      pageName:"",

      // 新增鸿蒙检测相关数据
      harmonyDetectVisible: true,
      harmonyVersion: '',
      harmonyUserAgent: '',
      harmonyDetectionResult: null
    }
  },
  created() {    
    // 标识使用手机号登录优先的sdk地址，涉及到悬浮窗换绑相关逻辑
    this.pageName = this.$store.state.user.app_name;
    localStorage.setItem('isV2Sdk', true);
    this.$store.commit('user/CHANGE_STATE', { loginVisible: true, cellLoginVisible: false });
    this.$store.commit('global/handleLinkParams', this.$route.query);
    this._handleType();

    // 鸿蒙检测
      this.checkHarmonyOS();

    if (this.$route.name == 'h5.silentLogin') {
      this.$store.commit('user/CHANGE_STATE', { loginVisible: false, cellLoginVisible: false });
      this.$setStorage('isSilentLogin', true);
    } else {
      this.$setStorage('isSilentLogin', false);
    }
    if (this.$route.name === 'h5.external') {
      this._externalInit();
      let iosTips = getStorage('iosTips');
      //let isSafari = (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)> -1) ;
      console.log('------isSafari',isSafari());
    
      if('iphone' == isSysName() && !iosTips && isSafari() && !isStandalone() ){
        console.log('------isSysName',isSysName());
        this.$store.commit('user/CHANGE_STATE', { iosTips: true }, { root: true });
      }
    } else if (!isAndroid()) {

      let iosTips = getStorage('iosTips');
      //let isSafari = (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)> -1) ;
      console.log('------isSafari',isSafari());
    
      if('iphone' == isSysName() && !iosTips && isSafari() && !isStandalone() ){
        console.log('------isSysName',isSysName());
        this.$store.commit('user/CHANGE_STATE', { iosTips: true }, { root: true });
      }

      this._iosInit();
    }
    this._handleSkin();
  },
  mounted() {
    this.$store.dispatch('user/getCacheState');
    this._bridgeInit();

    // 鸿蒙检测 - 延迟执行以确保页面加载完成
    setTimeout(() => {
      this.checkHarmonyOS();
    }, 1000);
  },
  computed: {
    ...mapState({
      userState: state => state.user,
      voucherState: state => state.voucher,
      loginStatus: state => state.user.login_status,
      gameSrc: state => state.user.game_url,
      policyVisible: state => state.global.policyVisible,
      captchaStatus: state => state.user.captcha_status,
      activityShowInfo: state => state.activity.activity_show_info || {},
      background: state => state.user.background,
      guideRemindVisible: state => state.pay.guideRemindVisible,
      hintShow: state => state.user.silentHintShow,
      guideBrowserVisible: state => state.pay.guideBrowserVisible,
    })
  },
  watch: {
    // 初始化后监听captcha_status判断当前包是否开启滑块验证
    // captchaStatus(val) {
    //   if (val == '1') {
    //     this._captchaInit();
    //   }
    // }
  },
  components: {
    QuickRegister,
    CellLogin,
    Login,
    Suspend,
    Reset,
    Affiche,
    AntiIndulged,
    Charge,
    Captcha,
    VipCustomer,
    Argument,
    FloatWindow,
    ForceBindPhone,
    ActivityPage,
    ForceOffline,
    UpdateGift,
    ArgumentTip,
    GuideRemind,
    iosTips
  },
  methods: {
    // 新增鸿蒙检测方法
    checkHarmonyOS() {
      try {
        const detectionResult = HarmonyDetector.detectHarmony();
        this.harmonyDetectionResult = detectionResult;
        
        if (detectionResult.isHarmonyOS || detectionResult.isHarmonyWebView) {
          console.log('🔍 检测到鸿蒙系统:', detectionResult);
          
          // 只在开发环境或特定条件下显示提示
          // if (process.env.NODE_ENV === 'development' || this.$route.query.debug === '1') {
            this.harmonyDetectVisible = true;
            this.harmonyVersion = detectionResult.version;
            this.harmonyUserAgent = detectionResult.userAgent;
          // }
          
          // 鸿蒙系统特殊处理逻辑
          this.handleHarmonyOSFeatures(detectionResult);
        } else {
          console.log('未检测到鸿蒙系统');
        }
        
        // 将检测结果存储到Vuex或本地存储
        this.$store.commit('user/CHANGE_STATE', {
          harmonyDetectionResult: detectionResult
        });
        
        // 发送鸿蒙检测数据到游戏框架
        this.sendHarmonyDetectionToGame(detectionResult);
        
      } catch (error) {
        console.error('鸿蒙系统检测失败:', error);
      }
    },
    
    // 鸿蒙系统特殊功能处理
    handleHarmonyOSFeatures(detectionResult) {
      // 1. 调整UI适配
      if (detectionResult.isHarmonyWebView) {
        // 鸿蒙WebView可能需要特殊样式调整
        document.documentElement.classList.add('harmony-webview');
      }
      
      // 2. 性能优化
      if (detectionResult.version && parseFloat(detectionResult.version) >= 3.0) {
        // HarmonyOS 3.0+ 的特殊优化
        console.log('HarmonyOS 3.0+ 检测到，启用性能优化');
      }
      
      // 3. 功能检测
      this.detectHarmonyCapabilities();
    },
    
    // 检测鸿蒙特有功能
    detectHarmonyCapabilities() {
      const capabilities = {
        // 检查鸿蒙特有API
        hasHarmonyObject: typeof window.Harmony !== 'undefined',
        hasHmosObject: typeof window.hmos !== 'undefined',
        
        // 检查设备能力
        hasTouch: 'ontouchstart' in window,
        hasPointer: 'PointerEvent' in window,
        
        // 检查Web API支持
        hasWebGL: !!window.WebGLRenderingContext,
        hasServiceWorker: 'serviceWorker' in navigator,
        hasPushManager: 'PushManager' in window
      };
      
      console.log('鸿蒙系统能力检测:', capabilities);
      return capabilities;
    },
    
    // 发送检测结果到游戏框架
    sendHarmonyDetectionToGame(detectionResult) {
      if (window.frames['gameFrame'] && window.frames['gameFrame'].contentWindow) {
        try {
          window.frames['gameFrame'].postMessage({
            action: 'harmonyDetection',
            data: detectionResult,
            timestamp: Date.now()
          }, '*');
        } catch (error) {
          console.warn('发送鸿蒙检测数据到游戏框架失败:', error);
        }
      }
    },
    
    // 关闭鸿蒙检测提示
    closeHarmonyDetect() {
      this.harmonyDetectVisible = false;
    },
    
    // 显示鸿蒙检测详情
    showHarmonyDetails() {
      const details = `
鸿蒙系统检测详情：
- 系统类型: ${this.harmonyDetectionResult.isHarmonyOS ? '鸿蒙系统' : '非鸿蒙系统'}
- WebView环境: ${this.harmonyDetectionResult.isHarmonyWebView ? '是' : '否'}
- 系统版本: ${this.harmonyDetectionResult.version}
- 设备类型: ${this.harmonyDetectionResult.deviceType}
- 用户代理: ${this.harmonyDetectionResult.userAgent}
- 平台: ${this.harmonyDetectionResult.platform}
- 检测时间: ${new Date(this.harmonyDetectionResult.timestamp).toLocaleString()}
      `;
      
      alert(details);
      
      // 复制到剪贴板
      navigator.clipboard.writeText(details).then(() => {
        console.log('鸿蒙检测详情已复制到剪贴板');
      });
    },
    _bridgeInit() {
      // 初始化客户端传过来的信息
      registJSInitial(async (e, cb) => {
        console.log('--- registJSInitial start ---')
        // ios h5通过链接获取设备参数，不会进这里
        let data = JSON.parse(e);
        const { user_info, jsDataStorage, third_sdk_status } = data;

        // 壳子缓存的用户列表不为空，则拿到用户列表
        if (user_info && user_info.length) {
          this.$store.commit('user/CHANGE_STATE', {
            userList: user_info,
            username: user_info[0].username,
            password: user_info[0].password
          });
        }
        // 存储传过来的信息
        this.$store.commit('user/CHANGE_STATE', {
          sdk_version: data.sdk_version,
          device_info: data.attributeReportParams,
          appkey: data.jh_app_id,
          channel: data.jh_channel,
          extra_data: JSON.stringify(data.extra_data),
          game_version: data.game_version,
          login_status: jsDataStorage || '',
          third_sdk_status: third_sdk_status || '',
          isEmulator: data.isEmulator,
          isInstallWeChat: data.isInstallWeChat,
          isInstallAlipay: data.isInstallAlipay,
        });

        // 强制正常登录
        if (third_sdk_status == 'false') {
          this.$store.commit('user/CHANGE_STATE', { login_status: 2 });
        }
        // 缓存信息
        const cacheList = [
          'login_status',
          'sdk_version',
          'device_info',
          'appkey',
          'channel',
          'extra_data',
          'game_version',
          'third_sdk_status',
          'isEmulator',
          'isInstallWeChat',
          'isInstallAlipay'
        ];
        this.$store.dispatch('user/cacheState', cacheList);

        // 应用宝强制正常登录
        if (data.third_sdk_status === false) {
          setStorage('force_normal_login', 2);
        }

        this.$store.dispatch('user/getYsdkStatus', 1);
        this.$store.dispatch('user/affiche');
        this.silentLogin();
      });
      thirdPartyLogins((e, cb) => {
        console.log('--- third login start ---')
        let data = JSON.parse(e);
        if (data.isHuaWei) {
          // 针对华为审核不能存在第三方账号体系做处理
          this.$store.dispatch('user/huaweiThirdLogin');
        } else {
          this.$store.commit('user/CHANGE_STATE', { username: data.user_name, password: data.origncv });
          this.userState.loginStatus != 2 && this.$store.dispatch('user/login', true);
        }
      });
      // 应用宝内购
      innerPurchaseFunctionSuc(async (e, cb) => {
        console.log('--- 应用宝内购 ---')
        this.$store.commit('pay/CHANGE_STATE', { yyb_info: JSON.parse(e) });
        this.$store.dispatch('pay/yybInnerPay')
        cb('yyb_Success');
      });
      // 关闭订单窗口
      closeOrderFrame((e, cb) => {
        this.$store.commit('pay/CHANGE_STATE', {
          orderIframeLink: '',
          orderShow: false,
          chargeOrNot: false
        });
        // 重复点击处理
        this.$store.commit('global/CHANGE_STATE', { preventBrush: false });
      });
      // 查询订单结果
      checkOrderState((e, cb) => {
      
       
        const params = {
          code: 1,
          msg: 'ok',
        };
        window.frames['gameFrame'].postMessage({ action: 'orderCallback', params }, '*');
      
      
        this.$store.dispatch('pay/queryOrderResult');
      });
      // 手机翻转
      deviceFlip2H5((e, cb) => {
        const hidefloat = this.$getStorage('hidefloat');
        if (hidefloat) return;
        this.$store.commit('user/CHANGE_STATE', { suspendVisible: !this.$store.state.user.suspendVisible });
      })
      onBackPressed2H5((e, cb) => {
        if (this.userState.game_url) {
          this.$store.commit('user/CHANGE_STATE', {
            cellLoginVisible: false,
            quickRegisterVisible: false,
            loginVisible: false,
            resetVisible: false
          });
        }
        cb('onBackPressed2H5 success')
      })
    },
    _handleSkin() {
      const { skin } = this.$route.query;
      this.$setStorage('skin', skin || '');
    },
    async _iosInit() {
      const { initial, iosThirdPacket } = this.$route.query;
      if (iosThirdPacket) {
        // ios三方买包
        await this.$store.dispatch('user/initIosThirdDeviceData', this.$route.query);
      } else if (initial) {
        // ios 非jsbridge形式传递设备信息处理
        await this.$store.dispatch('user/initDeviceData', this.$route.query);
      }
      getInitialInfo((e) => {
        const { extra_data } = this.$store.state.user;
        const _extraData = JSON.parse(extra_data);
        _extraData.caid = e.caid;
        this.$store.commit('user/CHANGE_STATE', { extra_data: JSON.stringify(_extraData) });
      })
      this.silentLogin();
    },
    // 使用安卓参数，外链形式提供给玩家在浏览器游戏初始化方式
    _externalInit() {

      this.$store.dispatch('user/initExternalData', this.$route.query);
      this.$setStorage('externalLogin', true);
      this.hideRegister = true;
      this.$store.commit('user/CHANGE_STATE', { loginVisible: true, cellLoginVisible: false });
    },
    captchaInit() {
      CaptchaInit(
        "captcha",
        (data) => {
          this.$store.commit("user/CHANGE_STATE", { captchaVisible: false });
          CaptchaReset()
          this.registerCallback && this[this.registerCallback](data);
        },
        (err) => {
          CaptchaReset()
          console.log(err);
        }
      );
    },
    _handleType() {
      const v2LoginType = localStorage.getItem('v2LoginType');
      const normalUserList = getAccount() || [];
      const cellUserList = getCellAccount() || [];
      // 先兼容老包用户有账号缓存无手机号缓存情况下，默认显示账号登陆 然后判断若上次玩家登录为账号登陆，则显示账号登陆
      if ((!v2LoginType && !cellUserList.length && normalUserList.length) || v2LoginType == 'normal') {
        this.redirectAccountLogin();
      }
    },
    agreeArgument() {
      const { method, params } = this.argumentHandle;
      this.argumentTipVisible = false;
      this[method]({
        ...params,
        agreementState: true
      })
    },
    // 滑块设置回调
    setRegisterCallback(cb, form) {
      this.registerCallback = cb;
      if (form) this.cellForm = form
    },
    async toLogin() {
      const r = await this.$store.dispatch('user/login');
      localStorage.setItem('v2LoginType', 'normal');
      localStorage.setItem('agreement_flag', 1);
      // 特殊情况
      if (r.content.login_status) {
        this.$store.commit('global/clearLoading')
        return;
      }

      // 登录后强制绑定手机判断
      const { force_bind_tel, show_tel_bind } = r.content;
      if ([1, 2, 3].includes(force_bind_tel) || show_tel_bind) {
        if (show_tel_bind && ![1, 2, 3].includes(force_bind_tel)) this.normalTelBind = true
        // force_bind_tel为2时提示用户绑定手机，但可正常进入游戏
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: true });
        this.$store.commit('global/clearLoading')
        return;
      }
      // 继续处理vip和防沉迷
      this.handleLoginInfo()
    },
    async cellLogin(form) {
      if (!form.agreementState) {
        this.argumentHandle = {
          method: 'cellLogin',
          params: form
        }
        this.argumentTipVisible = true;
        return;
      }
      try {
        const r = await this.$store.dispatch('user/cellLogin', form);
        localStorage.setItem('v2LoginType', 'cell');
        localStorage.setItem('agreement_flag', 1);
        // 存储手机登录凭证
        if (r.content.login_credential && !form.credential) {
          saveCellAccount(form.tel_num, r.content.login_credential);
        }
  
        // 特殊情况
        if (r.content.login_status) {
          this.$store.commit('global/clearLoading');
          return;
        }
        // 登录后强制绑定手机判断
        const { force_bind_tel } = r.content;
        if ([1, 2, 3].includes(force_bind_tel)) {
          // force_bind_tel为2时提示用户绑定手机，但可正常进入游戏
          this.$store.commit('user/CHANGE_STATE', {
            forceBindVisible: true,
          });
          this.$store.commit('global/clearLoading');
          return;
        }
        this.handleLoginInfo();
      } catch (error) {
        if (error.ret && error.ret === 194) {
          delCellAccount(form.tel_num)
          setTimeout(() => {
            this.$refs.cellLogin.getCellList(1);
          });
        }
      }
    },
    handleLoginInfo() {
      // vip判断
      this.$store.dispatch('user/checkVip');

      // 防沉迷判断
      this.$store.dispatch('user/checkAntiIndulged').then(() => {
        this.$store.commit('user/CHANGE_STATE', { antiIndulgedVisible: true });
        this.$store.commit('global/clearLoading')
      }).catch(() => this.enterGame());
    },
    closeForceBind(type) {
      const { force_bind_tel } = this.userState
      if (!type && force_bind_tel == 1) {
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: false });
      } else {
        this.$store.commit('user/CHANGE_STATE', { forceBindVisible: false });
        this.$store.commit('global/showLoading')
        this.handleLoginInfo()
      }
    },
    enterGame() {
      // 如果进了防沉迷流程，关闭防沉迷窗口使用
      if (this.userState.antiIndulgedVisible) {
        this.$store.commit('user/CHANGE_STATE', { antiIndulgedVisible: false });
        this.$store.commit('global/showLoading')
      }
      if (this.userState.h5Preload) {
        // 如果开启了h5预加载，登录成功后再调用研发回调
        this.$store.dispatch('message/notifyLogin');
      } else {
        this.$store.dispatch('message/monitorInit')
        this.$store.commit('user/CHANGE_STATE', { gameVisible: true });
      }
    },
    handleLogin(form) {
      if (form && !form.agreementState) {
        this.argumentHandle = {
          method: 'handleLogin',
          params: form
        }
        this.argumentTipVisible = true;
        return;
      }
      this.$store.commit('user/CHANGE_STATE', form);
      this.toLogin();
    },
    redirectRegist() {
      this.$store.dispatch('user/refreshOaid');
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: false,
        loginVisible: false,
        quickRegisterVisible: true,
        cellLoginVisible: false,
      });
    },
    redirectCellLogin() {
      this.$store.commit("user/CHANGE_STATE", {
        loginVisible: false,
        cellLoginVisible: true,
        quickRegisterVisible: false,
        argumentVisible: false,
      });
    },
    redirectAccountLogin() {
      this.$store.commit("user/CHANGE_STATE", {
        loginVisible: true,
        cellLoginVisible: false,
        quickRegisterVisible: false,
        argumentVisible: false,
      });
    },
    argumentReturn() {
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: false,
      });
    },
    redirectForget() {
      this.$store.commit('user/CHANGE_STATE', {
        loginVisible: false,
        resetVisible: true
      });
    },
    redirectLogin() {
      this.$store.commit('user/CHANGE_STATE', {
        cellLoginVisible: false,
        quickRegisterVisible: false,
        resetVisible: false,
        loginVisible: true
      });
    },
    async handleQuickRegister(form) {
      if (!form.agreementState) {
        this.argumentHandle = {
          method: 'handleQuickRegister',
          params: {}
        }
        this.argumentTipVisible = true;
        return;
      }
      if (this.captchaStatus == '1') {
        // 滑块验证情况
        this.$store.commit('user/CHANGE_STATE', {
          captchaVisible: true
        });
        this.setRegisterCallback('captchaQuickRegister');
        return;
      }
      await this.$store.dispatch('user/quickRegister');
      this.toLogin();
    },
    async handleCellRegister(form) {
      if (this.captchaStatus == '1') {
        // 滑块验证情况
        this.$store.commit('user/CHANGE_STATE', {
          captchaVisible: true
        });
        this.setRegisterCallback('captchaCellRegister', form);
        return;
      }
      await this.$store.dispatch('user/cellRegister');
      this.toLogin();
    },
    closeAffiche() {
      this.$store.commit('user/CHANGE_STATE', { afficheShow: false });
    },
    closeChargeWindow() {
      this.$store.commit('user/CHANGE_STATE', { chargeVisible: false });
    },
    closeUpdateGift() {
      this.$store.commit('user/CHANGE_STATE', { updateGiftVisible: false });
    },
    closeGuideRemind() {
      this.$store.commit('pay/CHANGE_STATE', { guideRemindVisible: false });
    },
    redirectArgument(type) {
      this.$store.commit('user/CHANGE_STATE', {
        argumentVisible: true,
        argumentType: type
      });
    },
    hideGuideBrowser() {
      this.$store.commit('pay/CHANGE_STATE', {
        guideBrowserVisible: false
      });
    },
    /**
    * 带滑块验证的快速注册
    * @param {Object} validData 滑块验证成功相关信息
    */
    async captchaQuickRegister (validData) {
      await this.$store.dispatch('user/quickRegister', validData);
      await this.toLogin();
    },
    /**
    * 带滑块验证的手机注册
    * @param {Object} validData 滑块验证成功相关信息
    */
    async captchaCellRegister (validData) {
      await this.$store.dispatch('user/cellRegister', { ...this.cellForm, validData });
      await this.toLogin();
    },
    async silentLogin() {
      if (!this.$getStorage('isSilentLogin')) return;     
      await this.$store.dispatch('user/silentLogin');
      // 公告
      const { affiche_info } = this.userState;
      if (affiche_info && affiche_info.login_state == 0) {
        return;
      }
      this.handleLoginInfo();
    }
  }
}

</script>

<style lang="scss" module>
.h5sdk {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .gameFrame {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    /* background: #000000; */
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: 0;
  }

  // 鸿蒙检测提示样式
  .harmonyDetect {
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 9999;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 10px;
    padding: 15px;
    color: white;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    max-width: 300px;
    animation: slideIn 0.3s ease-out;
    
    @keyframes slideIn {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    
    .harmonyDetectContent {
      h3 {
        margin: 0 0 10px 0;
        font-size: 16px;
        font-weight: bold;
      }
      
      p {
        margin: 5px 0;
        font-size: 12px;
        word-break: break-all;
        opacity: 0.9;
      }
      
      .harmonyActions {
        display: flex;
        gap: 10px;
        margin-top: 10px;
        
        button {
          flex: 1;
          padding: 8px 12px;
          border: none;
          border-radius: 5px;
          background: white;
          color: #667eea;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.2s ease;
          
          &:hover {
            background: #f0f0f0;
            transform: translateY(-1px);
          }
          
          &:active {
            transform: translateY(0);
          }
        }
      }
    }
  }
  
  // 鸿蒙WebView特殊样式
  :global(.harmony-webview) {
    // 针对鸿蒙WebView的特殊样式调整
    input, button, select, textarea {
      -webkit-appearance: none;
    }
  }

  .mask {
    background: rgba(0, 0, 0, 0.6);
  }
  .outer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .argumentTip {
    z-index: 99;
  }
  .argument {
    z-index: 100;
  }
  .captcha {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 350px;
    height: 270px;
  }
  .hint {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    padding: 5px 15px;
    font-size: 14px;
    background-color: #ededf9;
    > span {
      color:  #FF3B36;
    }
  }
  .guideBrowser {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
  }
}
</style>
